module.exports = function getResource(label, vars = []) {
    let resources = {
        sameDayDelivery: 'Livraison le jour même',
        deliveringTo: 'Livrer à ',
        yourLocation: 'votre emplacement'
    };
    return resources[label];
};
